import { Component, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

import { CostCenter } from '../../../models/cost-center.model';
import { PaymentService } from '../../../services/payments.service';
import {
  GAPaymentType,
  GoogleAnalytics,
} from '../../../services/google-analytics.service';
import { OrderService } from '../../../services/order.service';

@Component({
  selector: 'app-sap-account',
  templateUrl: './sap-account.component.html',
  styleUrls: ['./sap-account.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SapAccountComponent {
  costCenter: CostCenter;

  closeWithWarning = false;

  constructor(
    private router: Router,
    private activeModal: NgbActiveModal,
    private paymentService: PaymentService,
    private orderSerivce: OrderService,
    private googleAnalytics: GoogleAnalytics
  ) {}

  onVerifiedSap(costCenter: CostCenter) {
    if (costCenter) {
      this.paymentService.saveSapAccount(costCenter).then((result) => {
        this.close(result);

        this.googleAnalytics.addPaymentInfo(
          this.orderSerivce.activeOrder,
          GAPaymentType.Sap
        );
      });
    } else {
      this.close();
    }
  }

  close(costCenter?: CostCenter) {
    this.activeModal.close(costCenter);
  }
}
